/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from "react";

export function ModalPrint({ onClose, onPrint }) {
  return (
    <div className="blackOverlay">
      <div className="vert-middle">
        <div className="loyaltyMembership start-program-main">
          <div className="newPopupTitle">
            <div className="popup-name">Print</div>
            <a className="popupClose" onClick={onClose}>
              <img alt="" src="/images/close.png" />
            </a>
          </div>
          <div className="newPopupContent">
            <div className="row">
              <div className="col-xs-12 printable-img-title">
                We offer two types of printouts.
              </div>
              <div className="col-sm-6">
                <a
                  className="printable-img print_cal_option"
                  onClick={() => onPrint("short")}
                >
                  <img alt="" src="/images/short.png" />
                  <div className="text-center">Short</div>
                </a>
              </div>
              <div className="col-sm-6">
                <a
                  className="printable-img print_cal_option"
                  onClick={() => onPrint("extensive")}
                >
                  <img alt="" src="/images/extensive.png" />
                  <div className="text-center">Extensive</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
